module.exports = __webpack_public_path__ + "8ee20ee957177bbbb4fd6be460606ba0.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sharing-center/shared-folders/manage/manage-shared-folder.html
// module id = 1877
// module chunks = 0